export default {"src":"/_next/static/media/illustration-heart-sparkle.620dd04c.svg","height":80,"width":148};